//@flow
import { urlsConstants } from './../_constants/urls.constant';
import { defaultService } from './defaultService';

export const estabelecimentoFinanceiroService = {
  doGet,
  doSave,
  findByFiltro,
  findAll,
};


function findAll() {
  return defaultService.doGet(`${urlsConstants.ESTABELECIMENTO}findAll`);
}

function findByFiltro(options: Options, filter: any): Promise<Array<>> {
  return defaultService.findByFiltro(
    `${urlsConstants.ESTABELECIMENTO}financeiro/list`,
    options,
    filter
  );
}

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.ESTABELECIMENTO}financeiro/${id}`);
}

function doSave(entity: any) {
  return defaultService.doSave(`${urlsConstants.ESTABELECIMENTO}financeiro/`, entity);
}